<div class="detail">
  <div class="location">
    <div class="marker">
      <i class="fa fa-map-marker"></i>
    </div>
    <muni-gameday-small-loading
      [visible]="isLoading | async"
      [renderContent]="false"
      class="loading"
    >
      <div
        [textContent]="(data | async)?.city | NullToDashes"
        class="city"
        data-automation-e2e-selector="profileOverviewCity"
      ></div>
      <span class="state" *ngIf="(data | async)?.state">, </span>
      <span
        [textContent]="(data | async)?.state || ''"
        class="state"
        data-automation-e2e-selector="profileOverviewState"
      ></span>
    </muni-gameday-small-loading>
  </div>
  <div class="moneyType">
    <div class="money">
      <i class="fa fa-money"></i>
    </div>
    <muni-gameday-small-loading
      [visible]="isLoading | async"
      [renderContent]="false"
      class="loading"
    >
      <div
        [textContent]="(data | async)?.moneyType?.name | NullToDashes"
        class="shortMoneyType"
        data-automation-e2e-selector="profileOverviewMoneyType"
      ></div>
    </muni-gameday-small-loading>
  </div>
</div>
